import template from './tc-calendar.html';
import TcCalendarModalController from './tc-calendar.controller'; // Import modal controller
import modalTemplate from './tc-calendar-modal.html';
import moment from 'moment';

function calendarDirective($uibModal) {
  "ngInject";

  return {
    restrict: 'E',
    scope: {
      onDateSelect: '&',   // Callback for date selection
      minDate: '=',        // Minimum allowed date (string or ISO format)
      maxDate: '=',        // Maximum allowed date (string or ISO format)
      buttonText: '=',
      disabled: '=',       // Disabled state
    },
    template: template,
    link: (scope) => {
      scope.openCalendar = function () {
        // Don't open calendar if disabled
        if (scope.disabled) {
          return;
        }
        const modalInstance = $uibModal.open({
          animation: true,
          template: modalTemplate, // Modal template
          controller: ['$scope', '$uibModalInstance', 'minDate', 'maxDate', TcCalendarModalController],
          controllerAs: 'vm',
          size: 'sm',
          windowClass: 'calendar-modal-window',
          resolve: {
            minDate: () => scope.minDate ? moment(scope.minDate).startOf('day') : null, // Pass minDate as moment object, normalized to start of day
            maxDate: () => scope.maxDate ? moment(scope.maxDate).startOf('day') : null, // Pass maxDate as moment object, normalized to start of day
          },
        });

        // Handle modal result
        modalInstance.result
          .then((selectedDate) => {
            if (scope.onDateSelect) {
              scope.onDateSelect({ selectedDate }); // Trigger parent callback
            }
          })
          .catch(() => {
            console.log('Calendar modal dismissed.');
          });
      };
    },
  };

}

export default ['$uibModal', calendarDirective];



// WEBPACK FOOTER //
// ./client/common/directives/calendar/tc-calendar.component.js